import api from "../api.js";

/**
 * Ticket service
 *
 * Exposes API methods that interact with Tickets endpoints.
 */
class TicketService {

	/**
	 * Search tickets seating data.
	 *
	 * @param {Object} options.Trains Train constraints
	 * @return {Promise} Resolves with API data
	 */
	static searchSeats({Trains}={}) {
		const params = {Trains: JSON.stringify(Trains)};
		return api.call({url: `/api/tickets/seats`, params}).then(({data}) => data);
	}


	/**
	 * Search available trains matching a ticket option query.
	 *
	 * @param {Integer} org ID
	 * @param {Object} query API query object
	 * @return {Promise} Resolves with API data
	 */
	static searchTrains(org, query) {

		const params = {...query};

		params.Tickets = JSON.stringify(
			Object.keys((params?.Tickets || {})).reduce((current, id) => {
				const count = params.Tickets[id];
				if (!count) return current;
				else return {...current, [id]: count};
			}, {})
		);

		return api.call({url: `/api/tickets/${org}/trains`, params}).then(({data}) => data);

	}

}

export default TicketService;
